import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { configure } from 'mobx';
import * as observableProfiler from 'observable-profiler';
import { Observable } from 'rxjs';
// app
import { AppModule } from './app/app.module';
// libs
import { environment } from './environments/environment';

configure({
  enforceActions: 'always',
  computedRequiresReaction: true,
  reactionRequiresObservable: true,
  observableRequiresReaction: true,
  disableErrorBoundaries: true,
});

if (environment.production) {
  enableProdMode();
} else {
  observableProfiler.setup(Observable);
}

platformBrowser()
  .bootstrapModule(AppModule, { ngZoneEventCoalescing: true })
  .then(ref => {
    if (!environment.production) {
      observableProfiler.track();
      (window as any).appStopProfiler = () => {
        ref.destroy();
        const subscribers = observableProfiler.track(false);
        observableProfiler.printSubscribers({
          reportInnerSubscriptions: true,
          subscribers,
        });
      };
    }
  })
  .catch(err => console.log(err));
